import { styled } from '@mui/material/styles';
import { Grid, Button } from '@mui/material';

// ===================== ROOT =====================
export const RootContainer = styled('div')(() => ({
  backgroundColor: '#F6F6F6',
}));

// ===================== LEGAL =====================
export const LegalContainer = styled(Grid)(({ theme }) => ({
  padding: '20px',
  backgroundColor: '#D9D9D9',
  borderRadius: '8px',
  marginTop: '40px',
  width: '100%',
  maxWidth: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: '20px 40px',
  },
  '& .title': {
    fontWeight: 'bold',
    color: '#000',
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      marginBottom: '6px',
    },
  },
  '& .text': {
    fontSize: '12px',
    color: '#000',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
}));

// ===================== FILTER BUTTON =====================
export const FilterButtonUpContainer = styled('div')({
  display: 'flex',
  position: 'fixed',
  right: '1px',
  bottom: '1px',
  zIndex: 1000,
  justifyContent: 'flex-end',
});

// ===================== BUTTONS =====================
export const ButtonUpMobile = styled(Button)(({ theme }) => ({
  marginRight: '5px',
  marginBottom: '5px',
  height: '60px',
  border: '1px solid #E5E5E5',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
  borderRadius: '100px',
  backgroundColor: theme.tertiary || '#000',
  fontWeight: 600,
  fontSize: '16px',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: theme.primary || '#333',
    color: theme.text1,
  },
}));

// ===================== ICON CONTAINER =====================
export const IconContainer = styled(Grid)(() => ({
  display: 'flex',
  gap: '8px',
  borderRadius: '6px',
  color: '#000000ff',
  padding: '0px 10px',
  width: 'fit-content',
  height: '30px',
  alignItems: 'center',
  marginTop: '3px',
}));

export const MonthsContainer = styled(Grid)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '4px',
  columnGap: '8px',
  borderRadius: '6px',
  color: '#000000ff',
  padding: '0px 10px',
  width: 'fit-content',
  maxWidth: '100%',
  height: 'auto',
  minHeight: '30px',
  alignItems: 'center',
  marginTop: '3px',
}));

// ===================== TAGS =====================
export const TagTitle = styled('span')(({ theme }) => ({
  fontSize: '16px',
  fontFamily: 'Open Sans, sans-serif',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}));

export const TagSubtitle = styled('span')(({ theme }) => ({
  display: 'inline-block',
  color: '#000000ff',
  fontSize: '14px',
  fontFamily: 'Open Sans, sans-serif',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}));

export const BorderedBoxStyle = styled(Grid)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  padding: '40px',
  marginBottom: '40px',
  p: { xs: 2, lg: 2, xl: 3 },
  [theme.breakpoints.down('sm')]: {
    padding: '20px',
  },
}));
